import {split, makeRules, reduce, pickBy, moment, minutes} from 'helpers';

export function encode(activity) {
  const { note, name, ts, time, duration, scheduleDate } = activity;
  const result = {
    description: note,
    summary: name,
    start: { date: moment.unix(ts || scheduleDate).format('YYYY-MM-DD') },
    ...recurrence(activity),
  }
  result.end = {...result.start};
  if (time) {
    const date = moment(result.start.date, 'YYYY-MM-DD');
    result.start.date = result.end.date = null;
    result.start.timeZone = result.end.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    date.add(minutes(time), 'minutes');
    result.start.dateTime = date.format(moment.ISO8601);
    result.end.dateTime = date.add(duration || 0, 'minutes').format(moment.ISO8601);
  }
  return result;
}

function recurrence(activity) {
  const match = rules.match(activity);
  if (match) {
    let { start, ...rule } = match;
    if (activity.endDate) {
      rule.until = moment.unix(activity.endDate).format('YYYYMMDD')
    }
    rule = reduce(rule, (result, value, key) => {
      result += result ? ';' : 'RRULE:';
      return result.concat(key, '=', value).toUpperCase();
    }, '').replace(';INTERVAL=1', '');
    return pickBy({
      start,
      recurrence: [ rule ],
    });
  }
}

export const rules = makeRules([
  ({ repeatCount, repeatType }) => repeatType == 'PeriodDays' && repeatCount && ({
    freq: 'daily',
    interval: repeatCount,
  }),
  ({ repeatDays, repeatType }) => repeatType == 'PerDay' && repeatDays == '1,2,3,4,5,6,7' && ({
    freq: 'daily',
  }),
  ({ repeatType, repeatCount, repeatDays }) => repeatType == 'Weekly' && ({
    freq: 'weekly',
    interval: repeatCount,
    byday: weekdays(repeatDays),
  }),
  ({ repeatType, repeatDays }) => repeatType == 'PerDay' && repeatDays && ({
    freq: 'weekly',
    byday: weekdays(repeatDays),
  }),
  ({ repeatType, months, repeatCount, repeatDays }) => repeatType == 'Yearly' && months == '1,2,3,4,5,6,7,8,9,10,11,12' && ({
    freq: 'monthly',
    byday: repeatCount + weekdays(repeatDays),
  }),
  ({ repeatType, repeatCount, repeatDays, scheduleDate }) => repeatType == 'Monthly' && ({
    freq: 'monthly',
    interval: repeatCount,
    start: {
      date: moment.unix(scheduleDate).date(repeatDays).format('YYYY-MM-DD'),
    },
  }),
  ({ repeatType, scheduleDate, repeatCount, months }) => repeatType == 'Yearly' && /^\d+$/.test(months) && ({
    freq: 'yearly',
    interval: 5,
    start: {
      date: moment.unix(scheduleDate).month(months - 1).date(repeatCount).format('YYYY-MM-DD'),
    },
  }),
]);

function weekdays(days) {
  const week = { 1: 'mo', 2: 'tu', 3: 'we', 4: 'th', 5: 'fr', 6: 'sa', 7: 'su' };
  days = split(days, ',').map(day => week[day]);
  days = days.sort(day => day == 'su' ? -1 : 0);
  return days.join(',');
}
